<template>
  <v-app class="primary register-app">
    <v-container fluid>
      <v-form lazy-validation ref="createForm">
        <v-layout align-center justify-center>
          <v-flex lg8 sm9 xs12>
            <v-card class="elevation-1 pt-4 px-6 pb-0">
              <v-card-text class="pt-2 px-6 pb-0">
                <v-layout ref="errorSection" wrap>
                  <v-flex v-if="errors" xs12>
                    <v-alert
                        :key="key"
                        :value="true"
                        color="error"
                        icon="warning"
                        outlined
                        v-for="(value, key) in errors"
                    >
                      <template v-for="(item) in value">{{ item }}</template>
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex class="xs12 wrap">
                    <div style="display: flex; align-items: center; ">
                      <img :src="require('@/assets/nepaliport_logo.png')" alt="Avatar"
                           style="width: 358px;">
                    </div>

                    <div class="mt-2" style="display: flex;">
                      <div class="app-name-panel">AGENCY ONLINE REGISTRATION</div>
                    </div>
                  </v-flex>

                  <header-text icon="mdi-alpha-a-box" text="Agency Information:"></header-text>

                  <v-flex xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Name of the Agency *"
                        outlined
                        type="text"
                        v-model="formData.agency_name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="pr-1" md6 xs12>
                    <v-autocomplete
                        :items="states"
                        :rules="[rules.required]"
                        @change="getDistricts($event)"
                        class="mr-1"
                        item-text="name"
                        item-value="id"
                        label="State *"
                        outlined
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex class="pl-1" md6 xs12>
                    <v-autocomplete
                        :items="districts"
                        :rules="[rules.required]"
                        @change="getMunicipalities($event)"
                        item-text="name"
                        item-value="id"
                        label="District *"
                        outlined
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex md5 xs12>
                    <v-autocomplete
                        :items="municipalities"
                        :rules="[rules.required]"
                        class="mr-2"
                        item-text="name"
                        item-value="id"
                        label="Municipality *"
                        outlined
                        v-model="formData.municipality_id"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex md2 sm4 xs4>
                    <v-text-field
                        :rules="[rules.required]"
                        class="mr-2"
                        label="Ward No. *"
                        outlined
                        type="number"
                        v-model="formData.ward_no"
                        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                    />
                  </v-flex>
                  <v-flex md5 sm8 xs8>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Street Address *"
                        outlined
                        type="text"
                        v-model="formData.street_address"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="pr-2" xs6>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Landline Number  *"
                        maxlength="9"
                        outlined
                        type="text"
                        v-model="formData.landline_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs6>
                    <v-text-field
                        :rules="[rules.required, rules.email]"
                        label="Email *"
                        outlined
                        type="text"
                        v-model="formData.agency_email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 xs12>
                    <file-input
                        :required="true"
                        :show-image="true"
                        :valid="logoFile.valid"
                        label="Logo (300 KB) *"
                        v-model="logoFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>

                  <header-text icon="mdi-file-document-box"
                               text="Documents Information:"></header-text>

                  <v-flex class="pr-1" sm6>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Company Registration No *"
                        outlined
                        type="text"
                        v-model="formData.registration_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="pl-1" sm6>
                    <formatted-date
                        :rules="[rules.required,rules.beforeToday]"
                        label="Company Registration Date (B.S.)*"
                        v-model="formData.registration_date"
                    ></formatted-date>
                  </v-flex>

                  <v-flex class="pr-1" sm6 xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        label="PAN/VAT No *"
                        outlined
                        type="text"
                        v-model="formData.vat_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="pl-1" sm6 xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        label="NRB Certificate No*"
                        outlined
                        type="text"
                        v-model="formData.nrb_ceritificate_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="pr-1" sm6 xs12>
                    <formatted-date
                        :rules="[rules.required,rules.afterToday]"
                        label="NRB Certificate Validity Date (B.S.)*"
                        v-model="formData.nepal_rastra_bank_license_expiry_date"></formatted-date>
                  </v-flex>

                  <v-flex class="pl-1" sm6 xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Tourism Board Certificate No *"
                        outlined
                        type="text"
                        v-model="formData.tourism_board_certificate_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="pr-1" sm6 xs12>
                    <formatted-date
                        :rules="[rules.required,rules.afterToday]"
                        label="Tourism Board Certificate Expiry Date *"
                        v-model="formData.tourism_board_certificate_expiry_date"
                    ></formatted-date>
                  </v-flex>
                  <v-flex class="pl-1" sm6 xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Domestic & Small Industries License No *"
                        outlined
                        type="text"
                        v-model="formData.domestic_small_industries_license_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex class="pr-1" sm6 xs12>
                    <file-input
                        :valid="taxClearanceFile.valid"
                        label="Latest Tax Clearance Certificate (300KB)"
                        v-model="taxClearanceFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>

                  <v-flex sm6 xs12>
                    <file-input
                        :required="true"
                        :valid="registeredDocumentFile.valid"
                        label="Company Registered Document (300KB*)"
                        v-model="registeredDocumentFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>
                  <v-flex class="pr-1" sm6 xs12>
                    <file-input
                        :required="true"
                        :valid="vatPanDocumentFile.valid"
                        label="VAT/PAN Certificate (300KB)*"
                        v-model="vatPanDocumentFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>
                  <v-flex class="pr-1" sm6 xs12>
                    <file-input
                        :required="true"
                        :valid="nrbLicenseFile.valid"
                        label="Nepal Rastra Bank License (300KB) *"
                        v-model="nrbLicenseFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <file-input
                        :required="true"
                        :valid="tourismBoardCertificateFile.valid"
                        label="Tourism Board Certificate *"
                        v-model="tourismBoardCertificateFile.file"
                    >
                    </file-input>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <file-input
                        :required="true"
                        :valid="dnsiLicenseFile.valid"
                        label="Domestic & Small Industries License Document (300KB)*"
                        v-model="dnsiLicenseFile.file"
                        :fileSize="300"
                    >
                    </file-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>

                  <header-text icon="mdi-account"
                               text="User Information:"></header-text>

                  <v-flex class="pr-2" xs6>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Full Name *"
                        outlined
                        type="text"
                        v-model="formData.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Position in the agency *"
                        outlined
                        type="text"
                        v-model="formData.position"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="pr-2" xs6>
                    <v-text-field
                        :rules="[rules.mobile_number]"
                        label="Mobile Number  *"
                        maxlength="10"
                        outlined
                        type="text"
                        v-model="formData.mobile_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs6>
                    <v-text-field
                        :rules="[rules.required]"
                        label="Email *"
                        outlined
                        type="text"
                        v-model="formData.email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pt-0 pb-5 px-1">
                <v-btn
                    @click="saveModel"
                    block
                    color="primary"
                    :loading="loading"
                    large
                >Proceed
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </v-app>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

import Http from "axios";
import {API_URL, API_VERSION} from "../../config/config.js";
//Other components
import FileInput from '../../components/FileInput'
import HeaderText from '../../components/HeaderText'
import {validationMixin} from '../../mixins/validationMixin'
import VuetifyDialogDatePicker from "../../components/OutlinedDatePicker";
import FormattedDate from "../../components/FormattedDate";

export default {
  components: {
    VuetifyDialogDatePicker, HeaderText,
    'file-input': FileInput, FormattedDate
  },
  data: () => ({
    logoFile: {file: null, valid: true},
    taxClearanceFile: {file: null, valid: true},
    registeredDocumentFile: {file: null, valid: true},
    vatPanDocumentFile: {file: null, valid: true},
    tourismBoardCertificateFile: {file: null, valid: true},
    trekkingLicenseCertificateFile: {file: null, valid: true},
    nrbLicenseFile: {file: null, valid: true},
    dnsiLicenseFile: {file: null, valid: true},
    registrationDate: false,
    loading: false,
    companyRegisteredFile: null,
    formData: {},
    fiscalYear: {},
    errors: [],
    passwordShow: false,
    confirmPasswordShow: false,
    states: [],
    districts: [],
    municipalities: []
  }),
  mixins: [validationMixin],
  computed: {
    ...mapGetters("Notification", ["snackbar"]),
    todayDate() {
      let d = new Date();
      return d.toISOString().substr(0, 10)
    },

  },
  methods: {
    ...mapActions("AuthUser", ["register", "resetState"]),
    ...mapMutations("TrekkingSingle", ["setTrekkingAgencyData"]),
    confirmed() {
      return (this.formData.password === this.formData.password_confirmation) ? '' : 'Password confirmation must match';
    },
    checkImageValid() {
      let allFileValid = true;
      if (!this.logoFile.file) {
        allFileValid = false;
        this.logoFile.valid = false;
      }
      if (!this.registeredDocumentFile.file) {
        allFileValid = false;
        this.registeredDocumentFile.valid = false;
      }

      if (!this.vatPanDocumentFile.file) {
        allFileValid = false;
        this.vatPanDocumentFile.valid = false;
      }

      // if (!this.trekkingLicenseCertificateFile.file) {
      //   allFileValid = false;
      //   this.trekkingLicenseCertificateFile.valid = false
      // }

      if (!this.tourismBoardCertificateFile.file) {
        allFileValid = false;
        this.tourismBoardCertificateFile.valid = false
      }

      if (!this.nrbLicenseFile.file) {
        this.nrbLicenseFile.valid = false;
        allFileValid = false;
      }
      if (!this.dnsiLicenseFile.file) {
        this.dnsiLicenseFile.valid = false;
        allFileValid = false;
      }
      return allFileValid;
    },
    loadFiscalYears() {
      Http.get(API_URL + API_VERSION + "/fiscal-year/fetch-all")
          .then(response => {
            const sortedResponse = response.data.data.sort((a, b) =>
                a.end_year > b.end_year ? 1 : -1
            );
            this.fiscalYear = sortedResponse[sortedResponse.length - 1];
          })
    },
    getStates() {
      Http.get(API_URL + API_VERSION + "/states/fetch-all")
          .then(response => {
            this.states = response.data.data;
          })
    },
    getDistricts(stateId) {
      Http.get(API_URL + API_VERSION + "/district/" + stateId)
          .then(response => {
            this.districts = response.data.data;
          })
    },
    getMunicipalities(districId) {
      Http.get(API_URL + API_VERSION + "/municipality/" + districId)
          .then(response => {
            this.municipalities = response.data.data;
          })
    },

    saveModel() {
      let imageValid = this.checkImageValid();
      if (this.$refs.createForm.validate() && imageValid) {
        let formData = new FormData();
        this.loading = true;
        formData.set("agency_name", this.formData.agency_name);
        formData.set("municipality_id", this.formData.municipality_id);
        formData.set("ward_no", this.formData.ward_no);
        formData.set("street_address", this.formData.street_address);
        formData.set("landline_number", this.formData.landline_number);
        formData.set("agency_email", this.formData.agency_email);
        formData.set('fiscal_year_id', this.fiscalYear.id)
        formData.set('agency_logo', this.logoFile.file)
        formData.set('agency_tax_clearance', this.taxClearanceFile.file)
        formData.set('company_registered_document', this.registeredDocumentFile.file)
        formData.set('pan_vat_certificate', this.vatPanDocumentFile.file)
        formData.set('vat_no', this.formData.vat_no)
        formData.set('registration_no', this.formData.registration_no)
        formData.set('registration_date', this.formData.registration_date)
        formData.set('trekking_license_no', this.formData.trekking_license_no)
        formData.set('trekking_license_certificate', this.trekkingLicenseCertificateFile.file)
        formData.set("trekking_license_certificate_expiry_date", this.formData.trekking_license_expiry_date);
        formData.set('nepal_rastra_bank_license_no', this.formData.nrb_ceritificate_no)
        formData.set('nepal_rastra_bank_license', this.nrbLicenseFile.file)
        formData.set("nepal_rastra_bank_license_expiry_date", this.formData.nepal_rastra_bank_license_expiry_date);
        formData.set('tourism_board_certificate__no', this.formData.tourism_board_certificate_no)
        formData.set('tourism_board_certificate', this.tourismBoardCertificateFile.file)
        formData.set("tourism_board_certificate_expiry_date", this.formData.tourism_board_certificate_expiry_date);

        formData.set('domestic_small_industries_license', this.dnsiLicenseFile.file);
        formData.set('domestic_small_industries_license_no', this.formData.domestic_small_industries_license_no);
        // formData.set("domestic_small_industry_expiry_date", this.formData.domestic_small_industry_expiry_date);
        formData.set("agency_user_name", this.formData.name);
        formData.set("position", this.formData.position);
        formData.set("mobile_number", this.formData.mobile_number);
        formData.set("email", this.formData.email);
        formData.set('nepal_rastra_bank_license', this.nrbLicenseFile.file);
        Http.post(API_URL + API_VERSION + '/trekking-system/trekking-agency/registration-code', formData).then(() => {
          this.$store.commit('TrekkingSingle/setTrekkingAgencyData', formData);
          this.$store.commit('Notification/showSuccess', 'Enter token to complete registration');
          this.$store.commit('AuthUser/setMobile', this.formData.mobile_number);
          // console.log(this.$store.state.TrekkingSingle.trekkingAgencyData);
          this.$router.replace("/trekking-system/register");
          this.loading = false;
        })
            .catch((error) => {
              if (parseInt(error.response.status) === 422 || parseInt(error.response.status) === 400) {
                this.errors = error.response.data.errors;
              }

              window.scrollTo(0, 0);
              this.loading = false;
            })
      } else {
        this.$store.commit("Notification/showError", 'Please enter all required details');
      }
    }
  },
  mounted() {
    this.getStates();
    this.loadFiscalYears();

    this.formData = {};
    this.errors = [];
    this.$refs.createForm.reset();
  }
};
</script>
